var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1216"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1216"
    },
    "bundlingPackage": "MeetingsPublic",
    "bundlingPackageVersion": "static-1.60765",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};